<template>
  <div class="detail-information interview-general-container">
    <!-- <p class="interview-title">{{ interview.name }}</p> -->
    <!-- <div class="question-list-info" v-if="isVisibleInfo && interview.type === 1">
        <div class="d-flex align-items-center" style="gap: 12px">
          <img
            src="/images/ai-info-brain.svg"
            loading="lazy"
            alt="analysis"
            width="33"
            height="36"
          />
          {{ resource["hrvenueInterviewQuestionListInfoText"] }}
        </div>
        <i
            class="icon-close" style="position: absolute; right: 16px;"
            @click="handleCloseQuestionListInfo"
          />
    </div> -->
    <div class="list-group">
      <h3 class="interview-detail-h3">
        {{ resource['hrvenue.interviewQuestionListTitle'] }}
      </h3>
      <draggable
        v-if="(isQuestionPage && !openAILoading) || !isQuestionPage"
        v-model="interview.questions"
        class="w-100"
        tag="div"
        handle=".handle"
        v-bind="dragOptions"
        :move="checkMove"
        @input="changed"
        @start="drag = true"
        @end="drag = false"
      >
        <transition-group type="transition" :name="!drag ? 'flip-list' : null" class="list-group__content">
          <interview-questions
            v-for="(item, index) in interview.questions"
            :is-editable="isEditable"
            :is-delete="isEditable"
            :total-question-count="totalQuestionCount"
            :key="'question' + item.id"
            :class="'question' + item.id"
            :isTimeLimitEmpty = item.isTimeLimitEmpty
            :isThinkTimeEmpty = item.isThinkTimeEmpty
            :indexAt="index"
            :isLast="index === interview.questions.length -1"
            :question="item"
            :order="index"
            :questionType="interview.type || null"
            @onDeleteQuestion="onDeleteQuestion"
          />
        </transition-group>
      </draggable>
      <div v-else-if="isQuestionPage && openAILoading" class="loading-container-custom">
        <div id="loading-custom"></div>
      </div>
      <div class="ml-auto w-100" v-if="!isQuestionPage">
        <div class="text-center w-100 add-new-button-content">
          <button
            class="btn lg with-icon text-purple mb-3 bg-transparent v2"
            id="addNewQuestionOne"
            name="addNewQuestionOne"
            :title="isEditable ? '' : resource['hrvenue.InterviewEdit.SendedInterviewNotEditQuestionMessage']"
            @click="isEditable ? createNewQuestion() : null"
          >
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" class="mr-2">
            <path d="M12.0007 8.66665H8.66732V12C8.66732 12.3666 8.36732 12.6666 8.00065 12.6666C7.63398 12.6666 7.33398 12.3666 7.33398 12V8.66665H4.00065C3.63398 8.66665 3.33398 8.36665 3.33398 7.99998C3.33398 7.63331 3.63398 7.33331 4.00065 7.33331H7.33398V3.99998C7.33398 3.63331 7.63398 3.33331 8.00065 3.33331C8.36732 3.33331 8.66732 3.63331 8.66732 3.99998V7.33331H12.0007C12.3673 7.33331 12.6673 7.63331 12.6673 7.99998C12.6673 8.36665 12.3673 8.66665 12.0007 8.66665Z" fill="#FF8D06"/>
            </svg>

            {{ resource['hrvenue.interviewAddNewQuestion'] }}
          </button>
        </div>
      </div>
      <div v-if="isQuestionPage && !openAILoading" class="question-generator-addBtn w-100">
        <div class="ml-auto w-100" v-if="isEditable">
          <div class="text-center w-100">
            <button
              class="btn lg with-icon text-purple mb-3 bg-transparent v2"
              id="addNewQuestionOne"
              name="addNewQuestionOne"
              @click="createNewQuestion"
            >
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" class="mr-2">
              <path d="M12.0007 8.66665H8.66732V12C8.66732 12.3666 8.36732 12.6666 8.00065 12.6666C7.63398 12.6666 7.33398 12.3666 7.33398 12V8.66665H4.00065C3.63398 8.66665 3.33398 8.36665 3.33398 7.99998C3.33398 7.63331 3.63398 7.33331 4.00065 7.33331H7.33398V3.99998C7.33398 3.63331 7.63398 3.33331 8.00065 3.33331C8.36732 3.33331 8.66732 3.63331 8.66732 3.99998V7.33331H12.0007C12.3673 7.33331 12.6673 7.63331 12.6673 7.99998C12.6673 8.36665 12.3673 8.66665 12.0007 8.66665Z" fill="#FF8D06"/>
              </svg>

              {{ resource['hrvenue.interviewAddNewQuestion'] }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="rectangle" v-if="!isQuestionPage">
      <b-row class="mb-2">
        <b-col>
          <div class="col-12 m-0 p-0">
            <h3 class="mb-2 interview-detail-h3">
              {{ resource['hrvenue.interviewChooseQuestionBank'] }}
            </h3>
            <p class="sm interview-detail-p">
              {{ resource['hrvenue.interviewQuestionBankDesc'] }}
            </p>
          </div>
        </b-col>
      </b-row>

      <b-row class="mb-4 interview-detail-search">
        <b-col>
          <div class="has-search">
            <i class="form-control-feedback" >
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M15.9772 14.4716H15.1872L14.9072 14.2016C16.1072 12.8016 16.7272 10.8916 16.3872 8.86157C15.9172 6.08157 13.5972 3.86157 10.7972 3.52157C6.56719 3.00157 3.00719 6.56157 3.52719 10.7916C3.86719 13.5916 6.08719 15.9116 8.86719 16.3816C10.8972 16.7216 12.8072 16.1016 14.2072 14.9016L14.4772 15.1816V15.9716L18.7272 20.2216C19.1372 20.6316 19.8072 20.6316 20.2172 20.2216C20.6272 19.8116 20.6272 19.1416 20.2172 18.7316L15.9772 14.4716ZM9.97719 14.4716C7.48719 14.4716 5.47719 12.4616 5.47719 9.97157C5.47719 7.48157 7.48719 5.47157 9.97719 5.47157C12.4672 5.47157 14.4772 7.48157 14.4772 9.97157C14.4772 12.4616 12.4672 14.4716 9.97719 14.4716Z" fill="#333"/>
              </svg>
            </i>
            <b-form-input
              id="search-quick-questions"
              name="search-quick-questions"
              v-model="searchText"
              @input="searchOnQuestions"
              :placeholder="resource['QuestionBank.searchPlaceHolder']"
            />
          </div>
        </b-col>
      </b-row>
      <div class="sub-nav-wrap">
        <b-nav class="sub-nav sub-nav--detail mb-4">
          <b-nav-item
            id="tab-hrcheckup-1"
            class="nav-item black"
            :active="tabIndex === 0"
            @click="changeTab(0)"
          >
            {{ resource['interviewDetail.QuestionListTitle'] }}
          </b-nav-item>

          <b-nav-item
            v-if="interview.position"
            id="tab-hrcheckup-2"
            class="nav-item black"
            :active="tabIndex === 1"
            @click="changeTab(1)"
          >
          {{ resource['interviewDetail.OpenAIQuestionTitle'] }}
          </b-nav-item>

          <b-nav-item
            v-if="interview.selectedJob"
            id="tab-hrcheckup-1"
            class="nav-item black"
            :active="tabIndex === 3"
            @click="changeTab(3)"
          >
          {{ resource['interviewDetail.AtsQuestionTitle'] }}
          </b-nav-item>

          <b-nav-item
            id="tab-hrcheckup-1"
            class="nav-item black"
            :active="tabIndex === 2"
            @click="changeTab(2)"
          >
          {{ resource['interviewDetail.GeneralQuestionTitle'] }}
          </b-nav-item>

        </b-nav>
      </div>
      <b-row v-if="tabIndex === 0" class="question-tab">
          <div v-if="questionGeneratorLoading" class="loading-container-custom">
            <div id="loading-custom"></div>
          </div>
          <div
            class="scroll-content"
            @scroll="doScrollQuestionGenerator"
            id="infinite-list"
            v-if="!questionGeneratorLoading && getSearchQuestionGeneratorList.length > 0"

          >
            <div
              v-for="(questionList, index) in getSearchQuestionGeneratorList"
              :key="index"
              :id="'accordion-' + index"
              class="question-tab__item accordion"
            >
              <b-card no-body>
                <b-card-header header-tag="header" role="tab" class="d-flex">
                  <b-form-checkbox
                      v-model="questionList.interview.selected"
                      :id="index + '' "
                      class="w-auto add-question-checkbox"
                      value="true"
                      button
                      @change="onSelectQuestionGenerator($event, questionList.interview, index)"
                    >
                    <div v-if="checkboxLoading === questionList.id" id="loading-custom" :style="'width: 15px; height:15px'"></div>
                    <i v-else :class="questionList.interview.selected ? 'icon-minus text-color-purple' : 'icon-add3 xl'" />
                  </b-form-checkbox>
                  <b-button block variant="info" v-b-toggle="`accordion-${index}`">
                    <div class="d-flex question-list-title-label">
                      <p class="text-left d-inline"> {{ questionList.interview.name }} </p>
                      <p class="question-tab__label">
                        {{ questionList.interview.interviewQuestions.length + ' ' + resource['interviewDetail.questionText']}}
                      </p>
                    </div>
                    <span class="when-closed"><i class="icon-down-arrow" aria-hidden="true"></i></span>
                  </b-button>
                </b-card-header>
                <b-collapse :id="`accordion-${index}`" accordion="my-accordion" role="tabpanel">
                  <b-card-body>
                      <ul>
                        <li
                          v-for="(question, index) in questionList.interview.interviewQuestions"
                          :key="index"
                        >
                          {{ question.title }}
                        </li>
                      </ul>
                  </b-card-body>
                </b-collapse>
              </b-card>
            </div>
            <div v-if="scrollLoading" class="d-flex justify-content-center align-items-center mt-2 mb-2">
              <div id="loading-custom" :style="'width: 30px; height:30px'"></div>
            </div>
          </div>
          <p
            v-else-if="!getSearchQuestionGeneratorList.length && !questionGeneratorLoading"
            class="question-tab__error"
          >
            <img
              :src="require('@/assets/hrVenue/search-ats.svg')"
              alt="icon search"
              height="80"
              class="mb-2"
            >
            {{ resource['label.NoResult'] }}
          </p>
      </b-row>
      <b-row v-if="tabIndex === 1" class="question-tab">
          <div v-if="openAILoading" class="loading-container-custom">
            <div id="loading-custom"></div>
          </div>
          <div class="question-tab__warning" v-if="getSearchQuestionListAI.length > 0 && aiWarning">
            <i class="icon-warning" />
            <p>
              {{ resource['interviewDetail.OpenAIQuestionWarning'] }}
            </p>
            <i
              class="icon-close"
              @click="() => toggleAiWarning()"
            />
          </div>
          <div
            class="scroll-content"
            @scroll="doScroll"
            v-if="getSearchQuestionListAI.length > 0"
          >
            <table class="table table-borderless mb-0">
              <div
                v-for="(question, index) in getSearchQuestionListAI"
                :key="index"
                class="pb-3 pt-3 pl-3 question-tab__item"
              >
                <tr>
                  <td class="m-0 p-0 checkout-td-size" v-if="isEditable">
                    <b-form-checkbox
                        v-model="question.selected"
                        :id="index + '' "
                        class="w-auto"
                        value="true"
                        button
                        @change="onSelectQuestionAI($event, question, index)"
                      >
                      <i :class="question.selected ? 'icon-minus text-color-purple' : 'icon-add3 xl'" />
                    </b-form-checkbox>
                  </td>
                  <td class="m-0 p-0 checkout-td-size" v-if="!isEditable">
                    <span
                      class="checkout-size icon-add3 text-color-white cursor-pointer"
                      title="Daha önce gönderdiğiniz bir mülakatın sorularını düzenleyemezsiniz"
                    />
                  </td>
                  <td class="m-0 p-0 mt-1">
                    <p class="lg table-question-title">
                      {{ question.title }}
                    </p>
                  </td>
                </tr>
                <tr>
                  <td class="m-0 p-0 checkout-td-size"></td>
                  <td class="m-0 p-0 pt-2">
                    <p class="sm question-tab__label">{{ resource['interviewDetail.OpenAIQuestionLabel'] }}</p>
                  </td>
                </tr>
              </div>
            </table>
          </div>
          <p
            v-else-if="!getSearchQuestionListAI.length && !openAILoading"
            class="question-tab__error"
          >
            <img
              :src="require('@/assets/hrVenue/search-ats.svg')"
              alt="icon search"
              height="80"
              class="mb-2"
            >
            {{ resource['label.FilterNoResult'] }}
          </p>
      </b-row>
      <b-row v-if="tabIndex === 2" class="question-tab">
          <div v-if="layout.loading" class="loading-container-custom">
            <div id="loading-custom"></div>
          </div>
          <div
          class="scroll-content"
            @scroll="doScroll"
            v-if="getSearchQuestionList.length > 0"
          >
            <table class="table table-borderless mb-0">
              <div
                v-for="(question, index) in getSearchQuestionList"
                :key="index"
                class="pb-3 pt-3 pl-3 question-tab__item"
              >
                <tr>
                  <td class="m-0 p-0 checkout-td-size" v-if="isEditable">
                    <b-form-checkbox
                        v-model="question.selected"
                        :id="index + '' "
                        class="w-auto"
                        value="true"
                        button
                        @change="onSelectQuestionDef($event, question, index)"
                      >
                      <i :class="question.selected ? 'icon-minus text-color-purple' : 'icon-add3 xl'" />
                    </b-form-checkbox>
                  </td>
                  <td class="m-0 p-0 checkout-td-size" v-if="!isEditable">
                    <span
                      class="checkout-size icon-add3 text-color-white cursor-pointer"
                      title="Daha önce gönderdiğiniz bir mülakatın sorularını düzenleyemezsiniz"
                    />
                  </td>
                  <td class="m-0 p-0 mt-1">
                    <p class="lg table-question-title">
                      {{ question.title }}
                    </p>
                  </td>
                </tr>
                <tr>
                  <td class="m-0 p-0 checkout-td-size"></td>
                  <td class="m-0 p-0">
                    <p class="sm question-tab__label">{{ resource["hrvenue.InterviewEdit.DefinedQuestion"]}}</p>
                  </td>
                </tr>
              </div>
              <div v-show="loading" class="loading-container-custom">
                <div id="loading-custom"></div>
              </div>
            </table>
          </div>

          <span
            class="question-tab__error"
            v-if="!loading && !layout.loading && !getSearchQuestionList.length"
          >
            <img
              :src="require('@/assets/hrVenue/search-ats.svg')"
              alt="icon search"
              height="80"
              class="mb-2"
            >
            {{ resource['label.FilterNoResult'] }}
          </span>
      </b-row>
      <b-row v-if="tabIndex === 3" class="question-tab">
          <div v-if="layout.loading" class="loading-container-custom">
            <div id="loading-custom"></div>
          </div>
          <div
            class="scroll-content"
            @scroll="doScroll"
            v-if="getSearchAtsQuestionList.length > 0"
          >
            <table class="table table-borderless mb-0">
              <div
                v-for="(question, index) in getSearchAtsQuestionList"
                :key="index"
                class="pb-3 pt-3 pl-3 question-tab__item"
              >
                <tr>
                  <td class="m-0 p-0 checkout-td-size" v-if="isEditable">
                    <b-form-checkbox
                        v-model="question.selected"
                        :id="index + '' "
                        class="w-auto"
                        value="true"
                        button
                        @change="onSelectQuestionATS($event, question, index)"
                      >
                      <i :class="question.selected ? 'icon-minus text-color-purple' : 'icon-add3 xl'" />
                    </b-form-checkbox>
                  </td>
                  <td class="m-0 p-0 checkout-td-size" v-if="!isEditable">
                    <span
                      class="checkout-size icon-add3 text-color-white cursor-pointer"
                      title="Daha önce gönderdiğiniz bir mülakatın sorularını düzenleyemezsiniz"
                    />
                  </td>
                  <td class="m-0 p-0 mt-1">
                    <p class="lg ml-2">
                      {{ question.title }}
                    </p>
                  </td>
                </tr>
                <tr>
                  <td class="m-0 p-0 checkout-td-size"></td>
                  <td class="m-0 p-0">
                    <p class="sm ml-2 question-tab__label">{{ resource['interviewDetail.AtsQuestionLabel'] }}</p>
                  </td>
                </tr>
              </div>
              <div v-show="loading" class="loading-container-custom">
                <div id="loading-custom"></div>
              </div>
            </table>
          </div>
          <span
            class="question-tab__error"
            v-if="!loading && !layout.loading && (!getSearchAtsQuestionList.length || getSearchAtsQuestionList?.length === 0)"
          >
            <img
              :src="require('@/assets/hrVenue/search-ats.svg')"
              alt="icon search"
              height="80"
              class="mb-2"
            >
            {{ resource['interviewDetail.AtsQuestionNoResult'] }}
          </span>
      </b-row>
    </div>
  </div>
</template>

<script>
import Draggable from 'vuedraggable';
import HrVenueService from '../../../services/hrvenue.service';
import { showNotification } from '../../../static/helpers';

export default {
  name: 'DetailInformation',
  components: {
    Draggable,
    InterviewQuestions: () => import('./interviewQuestions.vue'),
  },
  props: {
    interview: { type: Object, required: true },
    tempBankQuestion: { type: Array, required: true },
    bankQuestion: { type: Object, required: true },
    tempBankQuestionAI: { type: Array, required: true },
    bankQuestionAI: { type: Object, required: true },
    deletedQuestionAI: { type: Array, required: true },
    tempBankQuestionAts: { type: Array, required: true },
    bankQuestionAts: { type: Object, required: true },
  },
  data() {
    return {
      tabIndex: 0,
      aiWarning: true,
      openAILoading: true,
      questionGeneratorLoading: true,
      questionAI: [],
      questionDefs: [],
      questionGeneratorList: [],
      questionAts: [],
      firstTotalItemCount: null,
      searchText: '',
      debouncedTime: 0,
      reset: false,
      debouncedTimeForDeletion: 0,
      totalItemCount: 0,
      loading: false,
      layout: {
        loading: true,
      },
      paginationCount: {
        currentItemSize: 20,
        currentPageIndex: 1,
        total: 0,
        totalIndex: 0,
      },
      totalItemCountQuestion: 0,
      paginationCountQuestion: {
        currentItemSize: 20,
        currentPageIndex: 1,
        total: 0,
        totalIndex: 0,
      },
      totalQuestionList: 0,
      drag: false,
      pageType: '',
      checkboxLoading: null,
      scrollLoading: false,
      isScrollFetching: false,
      isVisibleInfo: true,
    };
  },
  async created() {
    this.pageType = this.$route.path.includes('/question-generator') ? 'question' : 'interview';
    if (!this.isQuestionPage) {
      this.getQuestions();
      this.getQuestionGeneratorList();
    }
    if (this.interview?.position?.id) {
      this.tabIndex = 1;
      try {
        const response = await HrVenueService.getSampleQuestions(this.interview?.position?.id, this.interview?.jobDescription || null, this.interview?.questionLanguage?.id || null);
        const list = response?.questions.map((quest) => ({
          title: quest,
          selected: false,
          positionId: this.interview?.position?.id,
        }));

        // eslint-disable-next-line no-plusplus
        for (let i = 0; i < list.length; i++) {
          if (this.bankQuestionAI.questions.length) {
            if (!this.checkAIQuestionBankItem(list[i])) {
              if (this.checkAITempQuestionBankItem(list[i])) {
                this.bankQuestionAI.questions.push(this.checkAITempQuestionBankItem(list[i]));
              } else {
                this.bankQuestionAI.questions.push({
                  ...list[i], selected: false, id: Math.random().toString(16).slice(2),
                });
              }
            }
          } else {
            this.bankQuestionAI.questions.push({
              ...list[i], selected: false, id: Math.random().toString(16).slice(2),
            });
          }
        }
        this.questionAI = [...this.bankQuestionAI.questions.filter((item) => item.title !== '' && item.positionId === this.interview?.position?.id)];

        if (this.isQuestionPage) {
          this.questionAI.map((question) => {
            const foundQuestion = this.interview.questions.findIndex((quest) => quest.title === question.title);
            // alttaki kontrol; AI ile oluşturulan bir soruyu preview ya da question list ekranında sildiyse, geri geldiğinde silinen sorunun tekrar eklememesi için
            const deletedQuestion = this.deletedQuestionAI.findIndex((quest) => quest.title === question.title);
            if (foundQuestion === -1 && deletedQuestion === -1) {
              this.onSelectQuestionAI(true, question);
            }
            return question;
          });
          this.interview.questions = this.interview.questions.filter((item) => item.title !== '' && item.positionId === this.interview?.position?.id);
        }
      } catch (error) {
        // error
      } finally {
        this.openAILoading = false;
      }
    } else {
      this.openAILoading = false;
    }

    if (this.interview?.selectedJob?.id) {
      this.tabIndex = 3;
      try {
        const list = this.interview.selectedJob?.questions?.map((item) => { item.selected = false; item.title = item.question; return item; }) || [];
        // eslint-disable-next-line no-plusplus
        for (let i = 0; i < list.length; i++) {
          if (this.bankQuestionAts.questions.length) {
            if (!this.checkAtsQuestionBankItem(list[i])) {
              if (this.checkAtsTempQuestionBankItem(list[i])) {
                this.bankQuestionAts.questions.push(this.checkAtsTempQuestionBankItem(list[i]));
              } else {
                const selectedQuestion = this.interview.questions.find((question) => question.title === list[i].question);
                this.bankQuestionAts.questions.push({
                  ...list[i], selected: !!selectedQuestion, id: Math.random().toString(16).slice(2),
                });
              }
            }
          } else {
            const selectedQuestion = this.interview.questions.find((question) => question.title === list[i].question);
            this.bankQuestionAts.questions.push({
              ...list[i], selected: !!selectedQuestion, id: Math.random().toString(16).slice(2),
            });
          }
        }
      } catch (error) {
        // error
      }
    }
  },
  computed: {
    getSearchQuestionList() {
      const questionList = this.questionDefs?.map((item) => { this.interview.questions.find((quest) => quest.title === item.title) ? item.selected = true : item.selected = false; return item; });
      return questionList;
    },
    getSearchAtsQuestionList() {
      const atsQuestionList = this.interview?.selectedJob?.questions?.map((item) => { this.interview.questions.find((quest) => quest.title === item.question) ? item.selected = true : item.selected = false; item.title = item.question; return item; });
      return atsQuestionList?.filter((item) => item.title
        .toLocaleLowerCase('tr')
        .match(this.searchText.toLocaleLowerCase('tr'))) || [];
    },
    getSearchQuestionListAI() {
      const aiQuestionList = this.questionAI?.map((item) => { this.interview.questions.find((quest) => quest.title === item.title) ? item.selected = true : item.selected = false; return item; });
      return aiQuestionList?.filter((item) => item.title
        .toLocaleLowerCase('tr')
        .match(this.searchText.toLocaleLowerCase('tr')));
    },
    getSearchQuestionGeneratorList() {
      return this.questionGeneratorList?.filter((item) => item.interview.name
        .toLocaleLowerCase('tr')
        .match(this.searchText.toLocaleLowerCase('tr')));
    },
    totalQuestionCount() {
      return this.interview.questions.length;
    },
    dragOptions() {
      return {
        animation: 200,
        group: 'description',
        disabled: false,
        ghostClass: 'ghost',
      };
    },
    isEditable() {
      if (this.interview.id) {
        return !this.interview.isSent;
      }
      return true;
    },
    isDelete() {
      return this.isEditable;
    },
    isQuestionPage() {
      return this.pageType === 'question';
    },
  },
  mounted() {
  },
  methods: {
    // eslint-disable-next-line no-unused-vars
    checkMove(evt) {
      return true;
    },
    // resetSearch() {
    //   if (!this.reset) {
    //     if (this.debouncedTimeForDeletion) {
    //       clearTimeout(this.debouncedTimeForDeletion);
    //     }
    //     this.debouncedTimeForDeletion = setTimeout(() => {
    //       if (this.searchText.length < 3 || this.searchText.length < 2) {
    //         this.reset = true;
    //         this.paginationCount.currentPageIndex = 1;
    //         this.paginationCount.total = 0;
    //         this.getQuestions(true);
    //       }
    //     }, 500);
    //   }
    // },
    searchOnQuestions() {
      if (this.debouncedTime) {
        clearTimeout(this.debouncedTime);
      }
      this.debouncedTime = setTimeout(() => {
        if (this.searchText.length > 2) {
          this.paginationCount.currentPageIndex = 1;
          this.paginationCount.total = 0;
          this.questionDefs = [];
          this.loading = false;
          this.layout.loading = true;
          this.getQuestions(true);
        } else if (!this.searchText.length) {
          this.paginationCount.currentPageIndex = 1;
          this.paginationCount.total = 0;
          this.questionDefs = [];
          this.loading = false;
          this.layout.loading = true;
          this.getQuestions(false);
        }
      }, 300);
    },
    async getQuestions(fromSearch) {
      const { totalItemCount, items } = await HrVenueService.getQuestionBanks(
        this.paginationCount.currentPageIndex,
        this.paginationCount.currentItemSize,
        this.searchText,
        this.interview?.questionLanguage?.id || null,
      );

      this.bankQuestion.questions = [];
      this.$emit('update:tempBankQuestion', []);
      this.questionDefs = [];

      const list = items;
      this.loading = false;
      this.layout.loading = false;
      this.totalItemCount = totalItemCount;
      this.firstTotalItemCount = this.firstTotalItemCount ? this.firstTotalItemCount : totalItemCount;
      this.paginationCount.total += list.length;
      this.paginationCount.totalIndex = Math.floor(totalItemCount / list.length);
      if (fromSearch) {
        this.$emit('update:tempBankQuestion', []);
        // eslint-disable-next-line no-plusplus
        for (let i = 0; i < list.length; i++) {
          if (!this.checkQuestionBankItem(list[i])) {
            this.tempBankQuestion.push({ ...list[i], selected: false, id: Math.random().toString(16).slice(2) });
          } else {
            this.tempBankQuestion.push(this.checkQuestionBankItem(list[i]));
          }
          if (!this.checkQuestionBankItem(list[i])) {
            this.bankQuestion.questions.push({ ...list[i], selected: false, id: Math.random().toString(16).slice(2) });
          }
        }
        this.questionDefs = [...this.tempBankQuestion];
      } else {
        // eslint-disable-next-line no-plusplus
        for (let i = 0; i < list.length; i++) {
          if (this.bankQuestion.questions.length) {
            if (!this.checkQuestionBankItem(list[i])) {
              if (this.checkTempQuestionBankItem(list[i])) {
                this.bankQuestion.questions.push(this.checkTempQuestionBankItem(list[i]));
              } else {
                this.bankQuestion.questions.push({ ...list[i], selected: false, id: Math.random().toString(16).slice(2) });
              }
            }
          } else {
            this.bankQuestion.questions.push({ ...list[i], selected: false, id: Math.random().toString(16).slice(2) });
          }
        }
        this.questionDefs = [...this.bankQuestion.questions];
      }
    },
    async getQuestionGeneratorList(scroll) {
      if (!scroll) {
        this.questionGeneratorLoading = true;
      } else {
        this.scrollLoading = true;
      }
      const {
        totalCount,
        items,
      } = await HrVenueService.getInterviews(
        true, // isActive
        this.paginationCountQuestion.currentPageIndex,
        this.paginationCountQuestion.currentItemSize,
        [2],
        null,
        false,
        0,
        0,
      );
      if (items) {
        this.questionGeneratorList.push(...items);
        this.totalItemCountQuestion = totalCount;
        this.paginationCountQuestion.total += items.length;
        this.paginationCountQuestion.totalIndex = Math.floor(totalCount / items.length);

        this.questionGeneratorList = this.questionGeneratorList.map((item) => {
          if (this.interview.addedQuestionList?.includes(item.interview.id)) {
            item.interview.selected = true;
          }
          return item;
        });
      } else {
        this.questionGeneratorList = [];
      }
      this.questionGeneratorLoading = false;
      this.scrollLoading = false;
    },
    checkQuestionBankItem(list) {
      // eslint-disable-next-line no-plusplus
      for (let i = 0; i < this.bankQuestion.questions.length; i++) {
        if (list.title === this.bankQuestion.questions[i].title) {
          return this.bankQuestion.questions[i];
        }
      }
      return false;
    },
    checkTempQuestionBankItem(list) {
      // eslint-disable-next-line no-plusplus
      for (let i = 0; i < this.tempBankQuestion.length; i++) {
        if (list.title === this.tempBankQuestion[i].title) {
          return this.tempBankQuestion[i];
        }
      }
      return false;
    },
    checkAIQuestionBankItem(list) {
      // eslint-disable-next-line no-plusplus
      for (let i = 0; i < this.bankQuestionAI.questions.length; i++) {
        if (list.title === this.bankQuestionAI.questions[i].title) {
          return this.bankQuestionAI.questions[i];
        }
      }
      return false;
    },
    checkAITempQuestionBankItem(list) {
      // eslint-disable-next-line no-plusplus
      for (let i = 0; i < this.tempBankQuestionAI.length; i++) {
        if (list.title === this.tempBankQuestionAI[i].title) {
          return this.tempBankQuestionAI[i];
        }
      }
      return false;
    },
    checkAtsQuestionBankItem(list) {
      // eslint-disable-next-line no-plusplus
      for (let i = 0; i < this.bankQuestionAts.questions.length; i++) {
        if (list.title === this.bankQuestionAts.questions[i].title) {
          return this.bankQuestionAts.questions[i];
        }
      }
      return false;
    },
    checkAtsTempQuestionBankItem(list) {
      // eslint-disable-next-line no-plusplus
      for (let i = 0; i < this.tempBankQuestionAts.length; i++) {
        if (list.title === this.tempBankQuestionAts[i].title) {
          return this.tempBankQuestionAts[i];
        }
      }
      return false;
    },
    doScroll(event) {
      if (this.totalItemCount > this.paginationCount.total) {
        const scrollHeight = event.target.scrollHeight;
        const scrollTop = event.target.scrollTop;
        const clientHeight = event.target.clientHeight;

        if (scrollTop + clientHeight >= scrollHeight) {
          this.paginationCount.currentPageIndex += 1;
          this.loading = true;
          this.getQuestions();
        }
      }
    },
    async doScrollQuestionGenerator(event) {
      if (this.totalItemCountQuestion > this.paginationCountQuestion.total) {
        const scrollHeight = event.currentTarget.scrollHeight;
        const scrollTop = event.currentTarget.scrollTop;
        const clientHeight = event.currentTarget.clientHeight;

        if (scrollTop + clientHeight >= scrollHeight && !this.isScrollFetching) {
          this.isScrollFetching = true;

          this.paginationCountQuestion.currentPageIndex += 1;
          this.totalQuestionList += this.paginationCountQuestion.total;

          try {
            await this.getQuestionGeneratorList(scroll);
            const item = `accordion-${this.totalQuestionList - 1}`;
            document.getElementById(item)?.scrollIntoView();
          } finally {
            this.isScrollFetching = false;
          }
        }
      }
    },
    changed() {
      this.$emit('input', {});
    },
    createNewQuestion() {
      if (this.interview.questions.length >= 20) {
        showNotification(
          this.resource['label.Error'],
          this.resource['hrvenue.InterviewEdit.InterviewMaxQuestionMessage'],
          'error',
        );
      } else {
        this.$emit('addNewQuestion');
        dataLayer.push({
          event: 'ga4_event',
          page_type: 'interview-create',
          site_type: 'interview',
          event_name: 'interview_form',
          event_parameters: {
            label: 'add-new-question',
            step: 2,
            option: this.interview.type === 3 ? 'person-interview-click' : 'video-interview-click',
            ats_integration: this.interview.isAtsIntegrationsEnabled ? 'yes' : 'not-selected',
          },
        });
      }
    },
    onDeleteQuestion(indexAt, question) {
      this.$emit('deleteQuestion', indexAt, question);

      if (question.questionGeneratorId) {
        const hasMatchingQuestion = this.interview.questions.some((q) => q.interview.questionGeneratorId === question.interview.questionGeneratorId);
        if (!hasMatchingQuestion) {
          this.questionGeneratorList = this.questionGeneratorList.map((quest) => { if (quest.interview.id === question.interview.questionGeneratorId) { quest.interview.selected = false; } return quest; });
        }
      }
    },

    onSelectQuestionDef(event, question) {
      if (event) {
        this.tempBankQuestion.map((quest) => { if (quest.title === question.title) { quest.selected = true; } return quest; });
        this.bankQuestion.questions = this.bankQuestion.questions.map((quest) => { if (quest.title === question.title) { quest.selected = true; } return quest; });
        this.interview.questions.push({
          ...question,
        });
        this.interview.questions = this.interview.questions.filter((item) => item.title !== '');
      } else {
        this.tempBankQuestion.map((quest) => { if (quest.title === question.title) { quest.selected = false; } return quest; });
        this.bankQuestion.questions = this.bankQuestion.questions.map((quest) => { if (quest.title === question.title) { quest.selected = false; } return quest; });
        const foundQuestion = this.interview.questions.find((quest) => quest.title === question.title);
        this.onDeleteQuestion(0, foundQuestion);
      }
    },

    onSelectQuestionATS(event, question) {
      if (event) {
        this.tempBankQuestionAts.map((quest) => { if (quest.title === question.title) { quest.selected = true; } return quest; });
        this.bankQuestionAts.questions = this.bankQuestionAts.questions.map((quest) => { if (quest.title === question.title) { quest.selected = true; } return quest; });
        this.interview.questions.push({
          ...question,
        });
        this.interview.questions = this.interview.questions.filter((item) => item.title !== '');
      } else {
        this.tempBankQuestionAts.map((quest) => { if (quest.title === question.title) { quest.selected = false; } return quest; });
        this.bankQuestionAts.questions = this.bankQuestionAts.questions.map((quest) => { if (quest.title === question.title) { quest.selected = false; } return quest; });
        const foundQuestion = this.interview.questions.find((quest) => quest.title === question.title);
        this.onDeleteQuestion(0, foundQuestion);
      }
    },

    onSelectQuestionAI(event, question) {
      if (event) {
        this.tempBankQuestionAI.map((quest) => { if (quest.title === question.title) { quest.selected = true; } return quest; });
        this.bankQuestionAI.questions = this.bankQuestionAI.questions.map((quest) => { if (quest.title === question.title) { quest.selected = true; } return quest; });
        this.interview.questions.push({
          ...question,
          id: Math.random().toString(16).slice(2),
          thinkTime: this.isQuestionPage ? null : 30,
          timeLimit: this.isQuestionPage ? null : 60,
        });
        this.interview.questions = this.interview.questions.filter((item) => item.title !== '');
      } else {
        this.tempBankQuestionAI.map((quest) => { if (quest.title === question.title) { quest.selected = false; } return quest; });
        this.bankQuestionAI.questions = this.bankQuestionAI.questions.map((quest) => { if (quest.title === question.title) { quest.selected = false; } return quest; });
        const foundQuestion = this.interview.questions.find((quest) => quest.title === question.title);
        this.onDeleteQuestion(0, foundQuestion);
      }
    },

    async onSelectQuestionGenerator(event, questionList) {
      if (event) {
        this.checkboxLoading = questionList.id;
        if (questionList.interviewQuestions) {
          questionList.interviewQuestions.map((quest) => (
            this.interview.questions.push({
              ...quest,
              id: Math.random().toString(16).slice(2),
              thinkTime: null,
              timeLimit: null,
              interviewId: null,
              questionGeneratorId: questionList.id,
            })
          ));
          this.interview.questions = this.interview.questions.filter((item) => item.title !== '');
          const foundQuestionList = this.interview.addedQuestionList.find((id) => id === questionList.id);
          if (!foundQuestionList) {
            this.interview.addedQuestionList.push(questionList.id);
          }
          if (this.interview.questions.length > 20) {
            showNotification(
              this.resource['label.Warning'],
              this.resource['hrvenue.InterviewEdit.InterviewMaxQuestionMessage'],
              'warning',
            );
          }
          showNotification(
            this.resource['Label.Success'],
            this.resource['hrvenue.InterviewDetailAddedQuestionList'],
            'success',
          );
        }
        this.checkboxLoading = null;
      } else {
        this.interview.questions = this.interview.questions.filter((item) => item.questionGeneratorId !== questionList.id);
        this.interview.addedQuestionList = this.interview.addedQuestionList.filter((id) => id === questionList.id);
        if (this.interview.questions.length === 0) {
          this.createNewQuestion();
        }
      }
    },

    changeTab(index) {
      this.tabIndex = index;
    },

    toggleAiWarning() {
      this.aiWarning = false;
    },

    handleCloseQuestionListInfo() {
      this.isVisibleInfo = false;
    },
  },
};
</script>

<style lang="scss">
@import '~@/style/starter.scss';
.has-search .form-control {
  padding: 8px 28px 8px 8px !important;
}

.has-search .form-control-feedback {
  position: absolute;
  z-index: 2;
  display: block;
  width: 20px;
  height: 20px;
  right: 16px;
  top: 6px;
  line-height: 20px;
  text-align: center;
  pointer-events: none;
  color: #333;
  font-size: x-large;
}

.checkout-size {
  width: 20px;
  height: 20px;
}
.checkout-td-size {
  width: 20px;
}
.form-control-feedback {
  height: 100%;
}
.borderless table {
  border-top-style: none;
  border-left-style: none;
  border-right-style: none;
  border-bottom-style: none;
}
table {
  display: block;
}
.scroll-content{
  width: 100%;
  height: 385px;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 8px;

  &::-webkit-scrollbar {
    width: 7px !important;
  }

  &::-webkit-scrollbar-track {
    background-color: #fff !important;
    border-radius: 2px !important;
  }

  &::-webkit-scrollbar-thumb {
    border-radius: 2px !important;
    background: linear-gradient(to right, #d8d8d8 3px, #fff 4px) !important;
  }
}

.loading-container-custom{
  display: flex;
  justify-content: center;
  width: 100%;
  height: 266px;
  align-items: center;
}
#loading-custom {
  display: inline-block;
  width: 50px;
  height: 50px;
  border: 3px solid #e6e6e6;
  border-radius: 50%;
  border-top-color: #FF8D06;
  animation: spin 1s cubic-bezier(0.46, 0.03, 0.52, 0.96) infinite;
  -webkit-animation:spin 1s cubic-bezier(0.46, 0.03, 0.52, 0.96) infinite;
}

@keyframes spin {
  to { -webkit-transform: rotate(360deg); }
}
@-webkit-keyframes spin {
  to { -webkit-transform: rotate(360deg); }
}

.question-tab{
  min-height: 395px;

  &:has(.question-tab__warning) {
    .scroll-content {
      height: 335px;
    }
  }

  table {
    .question-tab__item {
      margin-bottom: 8px;
      padding: 16px !important;
    }

    .table-question-title {
      color: var(--text-colors-text-1, #353535);
      font-feature-settings: 'liga' off, 'clig' off;
      /* Typography(Yeni)/Subtitle/Aday/Small */
      font-family: Roboto;
      font-size: 14px !important;
      font-style: normal;
      font-weight: 500 !important;
      line-height: 140%;
    }
  }

  &__item {
    padding: 16px 16px 0px;
    border-radius: var(--Radius-Small, 4px) !important;
    background: var(--Background-Colors-Bright-Gray, #FAFAFA);
  }

  .card {
    width: 100%;
    border-radius: 4px;
    background: transparent !important;

    table {
      width: 100%;
    }
  }

  &__label {
    display: flex;
    width: fit-content;
    height: 24px;
    padding: 2px 8px;
    align-items: center;
    border-radius: 50px;
    border: 1px solid var(--stroke-colors-divider-line, #E4E4E4);
    background: var(--Background-Colors-Background, #EEE);
    font-size: 12px !important;
  }

  &__warning {
    display: flex;
    flex-direction: row;
    justify-content: start;
    align-items: center;
    padding: 6px 16px;
    gap: 8px;
    width: 100%;
    background: rgba(255, 141, 6, 0.1);
    border-width: 1px 0px;
    border-style: solid;
    border-color: #FFEEBA;
    color: #FF8D06;
    position: relative;
    margin-bottom: 8px;

    i {
      font-size: 16px;

      &:last-child {
        cursor: pointer;
        position: absolute;
        right: 16px;
      }
    }

    p {
      width: 90%;
      font-weight: 400;
      font-size: 12px;
      line-height: 18px;
    }
  }

  &__error {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
  }
}

.detail-information {
  display: flex;
  gap: 16px;

  @media only screen and (max-width: map-get($grid-breakpoints, "lg")) {
    flex-direction: column;
  }

  .btn-group-toggle {
    .btn {
      width: 30px !important;
      height: 30px !important;
      padding: 5px !important;
      display: flex !important;
      justify-content: center !important;
      align-items: center;
      gap: 10px;
      border-radius: var(--Radius-Round, 512px);
      border: 1px solid var(--Stroke-Colors-Secondary-Gray-Stroke, #D4D4D4);
      margin-right: 12px;
      position: relative;

      &.focus {
        box-shadow: none;
      }

      &:hover {
        background-color: #E4E4E4;
      }

      i {
        margin-right: 0;
      }
    }
  }

  .list-group {
    flex: 1;
    height: fit-content;
    margin-top: 16px;
    display: flex;
    padding: 24px 16px 16px;
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;
    border-radius: var(--Radius-Regular, 8px);
    border: 1px solid var(--stroke-colors-divider-line, #E4E4E4);
    background: var(--background-colors-white, #FFF);

    &__content {
      width: 100%;
    }
  }

  .rectangle {
    margin-top: 16px;
    width: 376px;
    height: 632px;
    position: sticky;
    top: 60px;

    @media only screen and (max-width: map-get($grid-breakpoints, "lg")) {
      width: 100%;
      height: auto;
      position: relative;
      top: 0;
    }

    .sub-nav-wrap {
      width: 100%;
      overflow: hidden;
      position: relative;

      &::before{
        content:'';
        height: 100%;
        width: 4px;
        background: linear-gradient(90deg, white 30%, rgba(255, 255, 255, 0) 100%);
        position: absolute;
        top:0;
        left:0;
        z-index:1;
      }
      &::after{
        content:'';
        height: 100%;
        width: 20px;
        background: linear-gradient(-90deg, white 30%, rgba(255, 255, 255, 0) 100%);
        position: absolute;
        top:0;
        right:0;
        z-index:1;
      }
    }

    .sub-nav--detail {
      border-bottom: 1px solid #e4e4e4;
      justify-content: flex-start !important;
      margin-bottom: 16px;

      &::-webkit-scrollbar {
        display: none !important;
      }

      .nav-item {
        a {
          font-size: 14px !important;
          font-weight: 400;
          &:after{
            content: "";
            position: absolute;
            left: 0;
            right: 0;
            bottom: 0;
            display: flex;
            width: 100%;
            height: 4px;
            background: transparent;
          }
          &.active {
            &:after{
              height: 4px;
              background: #FF8D06;
              border-top-left-radius: 4px;
              border-top-right-radius: 4px;
            }
          }
          @media only screen and (max-width: map-get($grid-breakpoints, "md")) {
            font-size: 14px;
          }
        }
      }
    }
  }
}

.question-generator-addBtn {
  @media only screen and (max-width: map-get($grid-breakpoints, "md")) {
    padding: 0 16px 16px;
  }
}

.interview-title {
  font-size: 14px;
  font-weight: 700;
  line-height: 18px;
  padding-top: 12px;
  @media only screen and (max-width: map-get($grid-breakpoints, "md")) {
    padding-left: 16px;
  }
}

.accordion {

  .card {
    border: 0;
    border-bottom: 1px solid #E4E4E4;

    &:last-child {
      border-bottom: 0;
    }

    .btn {
      padding: 0;
      display: flex;
      justify-content: space-between;
      height: auto;
      background: transparent !important;

      p {
        font-size: 14px;
        font-weight: 500;
        line-height: 20px;
        color: #353535;
      }

      &.focus {
        box-shadow: none;
      }
    }

    .collapsed>.when-closed {
      transform: rotate(0);
      transition: transform 0.35s;

      i {
        margin: 0;
      }
    }

    :not(.collapsed)>.when-closed {
      transform: rotate(180deg);
      transition: transform 0.35s;

      i {
        margin: 0;
      }
    }
  }

  .card-header {
    padding: 0 0 16px;
    background: none;
  }

  .card-body {
    background: #FAFAFA;
    border-top: 1px solid #E4E4E4;

    ul {
      padding-left: 20px;
      display: flex;
      gap: 8px;
      flex-direction: column;

      li {
        color:  #353535;
        font-size: 12px;
        font-weight: 400;
        line-height: 16px;
      }
    }
  }
}

.divider-container {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
  margin: 16px 0;
}

.divider {
  flex-grow: 1;
  height: 1px;
  background-color: #E4E4E4;
}

.interview-general-container {
  @media only screen and (max-width: map-get($grid-breakpoints, "md")) {
    margin-bottom: 50px;
    margin-top: 16px;
  }
}

#addNewQuestionOne{
  width: 100%;
  align-items: center;
  justify-content: center;
  text-align: center;
  margin-bottom: 0px !important;
  border-radius: var(--Radius-Regular, 8px);
  border: 1px dashed var(--Text-Colors-Primary-Orange-Text, #FF8D06);
}
.interview-detail-h3{
  font-family: Roboto;
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px;

  @media only screen and (max-width: map-get($grid-breakpoints, "md")) {
    margin-bottom: 16px !important;
  }
}
.interview-detail-p{
  @media only screen and (max-width: map-get($grid-breakpoints, "md")) {
    color: #858585;
    font-family: Roboto;
    font-size: 14px;
    font-weight: 700;
    line-height: 20px;
    margin-bottom: 16px;
  }
}
#search-quick-questions{
  @media only screen and (max-width: map-get($grid-breakpoints, "md")) {
    margin-bottom: 0px;
  }
}
.interview-detail-search{
  @media only screen and (max-width: map-get($grid-breakpoints, "md")) {
    margin-bottom: 16px !important;
  }
}
.add-new-button-content{
  @media only screen and (max-width: map-get($grid-breakpoints, "md")) {
    padding: 0 16px;
  }
}
.question-list-title-label{
  flex-direction: column;
  flex: 1;
  gap: 8px;
  padding-right: 12px;
}
.question-list-info {
  width: 100%;
  display: flex;
  padding: 8px 16px 8px 8px;
  align-items: center;
  gap: 12px;
  align-self: stretch;
  border-radius: 8px;
  border: 1px solid #FFBA43;
  background: #FFF6E5;

  color: #353535;
  font-family: Roboto;
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
  line-height: 20px;

  @media only screen and (max-width: map-get($grid-breakpoints, 'lg')) {
    gap: 8px;
  }
}
</style>
